/* Mobile size chart tabs */
var jquery = null;

if (window.jQuery) {
  jquery = window.jQuery;
} else if (window.Checkout && window.Checkout.$) {
  jquery = window.Checkout.$;
}
jQuery(document).ready(function(){
	jQuery('.scm_tbl').on('click', function(xx) {
	    xx.stopPropagation();
	});
	jQuery('.scm_tab').click(function(xx){
		jQuery('.scm_tab div.scm_tbl').slideUp();
		jQuery('.scm_tab img').attr('src', 'https://cdn.shopify.com/s/files/1/0697/1028/3007/files/arrow-closed.png?v=1720192786');

		if (!jQuery('.scm_tbl', this).is(':visible')){
			jQuery('.scm_tbl', this).slideDown();
			jQuery('img', this).attr('src', 'https://cdn.shopify.com/s/files/1/0697/1028/3007/files/arrow-open.png?v=1720192786');
		}
		
	});
});

jQuery(document).on('click', '.wfs-accordion', function(){
  jQuery('.wfs-accordion').removeClass('active');
  jQuery('.wfs-panel').slideUp();
  jQuery(this).toggleClass('active');
  jQuery(this).next('.wfs-panel').slideDown();
});

window.onload = function() {
    if (window.innerWidth <= 768) {
        const element = document.querySelector('.localization-selectors');
        if (element) {
            document.body.appendChild(element);
            element.style.position = 'fixed';
            element.style.bottom = '43px';
        }
    }
};